module.exports = __webpack_public_path__ + "static/data-cloud-59e945a57284bc8fb6688994e9b716a7.jpeg";